/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Rank_ContinentalInputs */



/**
* | output |
* | --- |
* | "Continental" |
*
* @param {Promo_Rank_ContinentalInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_rank_continental = /** @type {((inputs?: Promo_Rank_ContinentalInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Rank_ContinentalInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Continental")
	if (locale === "es") return /** @type {LocalizedString} */ ("Continental")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Continental")
	if (locale === "it") return /** @type {LocalizedString} */ ("Continentale")
	return /** @type {LocalizedString} */ ("Continental")
});